import React, { useState } from "react";
import { Intent } from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";
import styles from "./OpportunityDetails.module.scss";

export const useOpportunityDetailsAlert = () => {
  const defaultIcon = (
    <Icon
      name="warning-sign"
      color="#7a869b"
      size={32}
      className={styles.confirmAlertIcon}
    />
  );

  const dangerIcon = (
    <Icon
      name="warning-sign"
      color="#ec7c7c"
      size={32}
      className={styles.confirmAlertIcon}
    />
  );

  const successIcon = (
    <Icon
      name="warning-sign"
      color="#65cfa1"
      size={32}
      className={styles.confirmAlertIcon}
    />
  );

  const defaultAlertState = {
    visible: false,
    canEscapeKeyCancel: true,
    canOutsideClickCancel: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm",
    intent: Intent.DANGER,
    children: <p>Are You Sure?</p>,
    icon: defaultIcon
  };

  const [alertState, setAlertState] = useState(defaultAlertState);

  const onAlertStateChange = (newAlertState) => {
    setAlertState({
      ...defaultAlertState,
      ...newAlertState
    });
  };

  return {
    alertState,
    setAlertState: onAlertStateChange,
    defaultIcon,
    dangerIcon,
    successIcon
  };
};
